import { Form, InputNumber, Row, Col, Divider, Button } from "antd";
import "../VisorMartillo.css";

const PorcentajeProductos = () => {
  return (
    <>
      <Divider orientation='left' style={{ marginBottom: "4px", fontSize: "10px", fontWeight: "bold" }}>
        Porcentajes de productos (P.P)
      </Divider>

      <Row gutter={2} align='middle' wrap={false}>
        <Form layout='horizontal' size='small'>
          <Row gutter={1}>
            <Col xs={6}>
              <Form.Item
                label={
                  <span style={{ fontSize: "10px", whiteSpace: "normal" }}>
                    Rebate
                    <br />
                    Provee:
                  </span>
                }
                labelCol={{ style: { width: 40, fontSize: "10px" } }}
                wrapperCol={{ style: { width: 100 } }}
              >
                <InputNumber size='small' style={{ fontSize: "10px", width: "100%" }} />
              </Form.Item>
            </Col>

            <Col xs={6}>
              <Form.Item
                label={
                  <span style={{ fontSize: "10px", whiteSpace: "normal" }}>
                    Rebate
                    <br />
                    Lab:
                  </span>
                }
                labelCol={{ style: { width: 40, fontSize: "10px" } }}
                wrapperCol={{ style: { width: 100 } }}
              >
                <InputNumber size='small' style={{ fontSize: "10px", width: "100%" }} />
              </Form.Item>
            </Col>

            <Col xs={6}>
              <Form.Item
                label={
                  <span style={{ fontSize: "10px", whiteSpace: "normal" }}>
                    Pronto
                    <br />
                    Pago:
                  </span>
                }
                labelCol={{ style: { width: 40, fontSize: "10px" } }}
                wrapperCol={{ style: { width: 100 } }}
              >
                <InputNumber size='small' style={{ fontSize: "10px", width: "100%" }} />
              </Form.Item>
            </Col>

            <Col xs={6}>
              <Form.Item label=' ' colon={false}>
                <Button
                  size='small'
                  style={{
                    fontSize: "10px",
                    borderColor: "#7e202b",
                    color: "#7e202b",
                  }}
                >
                  Actualizar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
    </>
  );
};

export default PorcentajeProductos;
